<style lang="scss" scoped>
.query-form-div {
  padding: 12px;
}

.body-div {
  padding: 0 12px;
}

.pagination-div {
  padding: 12px;
  text-align: right;
}

.handle-div {
  padding: 12px;
  text-align: right;
}
</style>
<template>
  <div v-loading="allLoading" element-loading-text="数据加载中...">
    <div class="query-form-div">
      <el-form :inline="true" :model="qForm" v-if="formVisible">
        <el-form-item label="单位名称">
          <el-input size="small" v-model="qForm.UnitName" placeholder="请输入单位名称" />
        </el-form-item>
        <el-form-item label="姓名">
          <el-input size="small" v-model="qForm.UserName" placeholder="请输入运动员姓名" />
        </el-form-item>
        <el-form-item label="赛事名称">
          <el-select v-model="qForm.MatchId" clearable filterable remote reserve-keyword placeholder="请输入关键词"
            size="small" @clear="matchClear" @visible-change="matchClear" @change="matchSelectChange"
            :remote-method="remoteMethod">
            <el-option v-for="item in matchOptions" :key="item.MatchId" :label="item.MatchName" :value="item.MatchId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="组别" v-if="match && match.MatchGroups.length > 0">
          <el-select v-model="qForm.GroupId" clearable filterable remote reserve-keyword @change="groupSelectChange"
            size="small">
            <el-option v-for="item in match.MatchGroups" :key="item.GroupId" :label="item.GroupName"
              :value="item.GroupId">
              <span style="float: left">
                <i style="font-size: 14px;" :class="item.IsSuper == 1 ? 'el-icon-chaoe' : 'el-icon-pu'"></i>
                {{ item.GroupName }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目" v-if="projects && projects.length > 0">
          <el-select v-model="qForm.ProjectId" clearable filterable remote reserve-keyword size="small">
            <el-option v-for="item in projects" :key="item.ProjectId" :label="item.label" :value="item.ProjectId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" :loading="allLoading" @click="query(true)"
            size="small">查询</el-button>
          <el-button type="default" icon="el-icon-plus" :loading="allLoading" @click="showEditDialog()"
            size="small">添加</el-button>
          <el-button type="default" icon="el-icon-upload2" :loading="allLoading" size="small"
            @click="showUploadDialog">导入</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="body-div">
      <el-table :data="tb.data" style="width: 100%" stripe size="small" border>
        <el-table-column label="赛事名称" prop="MatchName" />
        <el-table-column label="赛事组别" prop="GroupName" />
        <el-table-column label="组别类型">
          <template v-slot="scope">
            {{ scope.row.IsSuper == 1 ? '超级组' : '普通组' }}
          </template>
        </el-table-column>
        <el-table-column label="项目" prop="ProNameAndGender" />
        <el-table-column label="运动员" prop="UserName">
          <template v-slot="scope">
            {{ scope.row.UserName }}
            <i class="el-icon-chazhaotihuan" style="font-size: 14px;cursor: pointer;" v-if="scope.row.SignUpFormId"
              @click="showUserReplaceDialog(scope.row)"></i>
          </template>
        </el-table-column>
        <el-table-column label="性别" prop="GenderText" width="80" />
        <el-table-column label="生日" prop="Birthday" width="100" />
        <el-table-column label="单位/学校" prop="Unit" />
        <el-table-column label="备注" prop="Remarks" />
        <el-table-column label="报名时间" prop="SignUpTime" :formatter="dataformatter" />

        <el-table-column label="操作" align="center" width="100">

          <template slot-scope="scope">
            <!-- v-if="scope.row.SignUpFormId == ''" -->

            <el-button circle type="default" icon="el-icon-edit" size="mini" v-if="scope.row.SignUpFormId == ''"
              @click.native.prevent="showEditDialog(scope.row)">
            </el-button>
            <el-button circle type="danger" icon="el-icon-delete" size="mini"
              @click.native.prevent="deleteMatchContestantUser(scope.row)">
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-div">
      <el-pagination background :current-page="tb.pi" :page-sizes="[10, 20, 40, 60, 100]" :page-size="tb.ps"
        layout="total, sizes, prev, pager, next, jumper" :total="tb.total" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
    </div>


    <el-dialog title="编辑报名信息" :visible.sync="editDialogVisible" width="800px">
      <el-form :model="editForm" ref="editForm" :rules="editFormRules" style="width: 80%;margin: 0 auto;"
        label-width="100px">
        <el-form-item label="赛事" prop="MatchId">
          <el-select v-model="editForm.MatchId" filterable @change="editMatchChange" size="small">
            <el-option v-for="item in allMatchs" :label="item.MatchName" :value="item.MatchId">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="分组" prop="GroupId">
          <el-select v-model="editForm.GroupId" @change="editGroupChange" :size="size">
            <el-option v-if="editFormMatch.MatchGroups" v-for="item in editFormMatch.MatchGroups"
              :label="item.GroupName" :value="item.GroupId">
              <i style="font-size: 14px;" :class="item.IsSuper == 1 ? 'el-icon-chaoe' : 'el-icon-pu'"></i>
              {{ item.GroupName }}
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目" prop="ProjectId">
          <el-select v-model="editForm.ProjectId" :size="size">
            <el-option v-for="item in editFormProject" :label="item.ProjectName" :value="item.ProjectId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="运动员" prop="UserName">
          <el-input type="textarea" v-model="editForm.UserName" :size="size"></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="Gender">
          <el-radio v-model="editForm.Gender" :label="0">男子</el-radio>
          <el-radio v-model="editForm.Gender" :label="1">女子</el-radio>
          <el-radio v-model="editForm.Gender" :label="2">男女混合</el-radio>
        </el-form-item>
        <el-form-item label="生日">
          <el-date-picker v-model="editForm.Birthday" type="date" placeholder="选择日期" :size="size">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="身份证号">
          <el-input type="textarea" v-model="editForm.IdentityCard" :size="size"></el-input>
        </el-form-item>
        <el-form-item label="单位/学校" prop="Unit">
          <!-- <el-input type="textarea" v-model="editForm.Unit" :size="size"></el-input> -->
          <el-autocomplete class="inline-input" v-model="editForm.Unit" :fetch-suggestions="querySearch"
            placeholder="请输入单位/学校" style="width: 100%;"></el-autocomplete>
        </el-form-item>
        <el-form-item label="报名时间" prop="SignUpTime">
          <el-date-picker v-model="editForm.SignUpTime" type="datetime" placeholder="选择日期" :size="size">
          </el-date-picker>

        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" v-model="editForm.Remarks" :size="size"></el-input>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false" :size="size">取 消</el-button>
        <el-button type="primary" @click="submitSignUpForm" :size="size">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="替换运动员" :visible.sync="editReplaceDialogVisible" width="800px">
      <el-form style="width: 80%; margin: 0 auto;" label-width="100px">
        <el-form-item label="原运动员">
          {{ editReplaceForm.UserName }}
        </el-form-item>
        <el-form-item label="运动员">
          <el-select v-model="editReplaceForm.NewAthleteIds" multiple filterable size="small" style="width: 100%;">
            <el-option v-for="item in unitAthletes" :key="item.AthleteId" :value="item.AthleteId"
              :label="item.UserName + (item.Gender == 0 ? '(男) ' : '(女) ') + item.Grade">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editReplaceDialogVisible = false" :size="size">取 消</el-button>
        <el-button type="primary" @click="submitReplaceForm" :size="size">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="导入" :visible.sync="uploadDialogVisible">
      <el-form style="width: 80%; margin: 0 auto;" label-width="100px">
        <el-form-item label="赛事">
          <el-select v-model="uploadData.matchId" filterable size="small">
            <el-option v-for="item in allMatchs" :label="item.MatchName" :value="item.MatchId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上传文件">
          <el-upload class="upload-demo" ref="upload" drag :action="uploadUrl" multiple :data="uploadData"
            :headers="requestHeaders" :auto-upload="false" accept=".xlsx" :limit="1" :on-change="uploadRequestChange"
            :on-error="uploadError" :on-success="uploadSuccess" :file-list="uploadFileList">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将xlsx文件拖到此处，或<em>点击上传</em></div>
          </el-upload>
          <label style="color: #409EFF;text-decoration: underline;" @click="downloadTemplate">下载导入模版</label>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="uploadDialogVisible = false" :size="size">取 消</el-button>
        <el-button type="primary" @click="sunmitUpload" :size="size">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import MatchService from "@/request-server/request-services/match-services.js";
import utilsCommon from "../../../utils/utils-common";
import Url from '../../../request-server/request-url';
import Store from '../../../store';
import Router from '../../../router';
export default {
  data() {
    return {
      size: 'small',
      allLoading: false,
      editDialogVisible: false,
      uploadDialogVisible: false,
      uploadFileList: [],
      formVisible: true,
      uploadUrl: Url.getRequestBaseUrl() + 'MatchApi/ImportMatchContestantUser',
      requestHeaders: {
        Authorization: 'Bearer ' + Store.state.token
      },
      uploadData: {
        matchId: "",
      },
      qForm: {
        UnitName: '',
        UserName: '',
        MatchId: "",
        GroupId: "",
        ProjectId: "",
      },

      editForm: {
        UserId: '',
        UserName: '',
        Gender: 0,
        Birthday: null,
        MatchId: '',
        GroupId: '',
        ProjectId: '',
        SignUpTime: null,
        IdentityCard: '',
        Unit: '',
        Remarks: '',
        SignUpTime: new Date()
      },
      editFormMatch: {
        MatchGroups: []
      },
      editFormGroups: [],
      editFormProject: [],

      editFormRules: {
        MatchId: [
          { required: true, message: '请选择赛事', trigger: 'blur' },
        ],
        GroupId: [
          { required: true, message: '请选择组', trigger: 'blur' },
        ],
        ProjectId: [
          { required: true, message: '请选择项目', trigger: 'blur' },
        ],
        Gender: [
          { required: true, message: '请选择性别', trigger: 'blur' },
        ],
        UserName: [
          { required: true, message: '请输入运动员', trigger: 'blur' },
        ],
        Unit: [
          { required: true, message: '请选择单位/学校', trigger: 'blur' },
        ],
        SignUpTime: [
          { required: true, message: '请输入报名时间', trigger: 'blur' },
        ],
      },

      matchOptions: [],
      allMatchs: [],
      match: null,
      projects: [],
      genderRuleList: [{ label: '男子', value: 0 }, { label: '女子', value: 1 }, { label: '男女混合', value: 2 }],
      genderRuleArr: ['男子', '女子', '男女混合'],
      tb: {
        pi: 1,
        ps: 10,
        total: 0,
        data: [],
      },
      unitAthletes: [],
      editReplaceDialogVisible: false,
      editReplaceForm: {
        UserId: '',
        UserName: '',
        OldAthleteIds: [],
        NewAthleteIds: [],
      },
      allUnits: [],
    };
  },
  created() {
    //this.getAllUnits();
    this.query();
    this.getAllMatchs();
  },
  methods: {
    // getAllUnits() {
    //   MatchService.selectAllUnitName({}).then(res => {
    //     if (res.code == 0) {
    //       this.allUnits = res.data;
    //     }
    //   })
    // },
    querySearch(queryString, cb) {
      var restaurants = this.allUnits;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.indexOf(queryString) > -1);
      };
    },
    query(isInit) {
      if (isInit) {
        this.tb.pi = 1;
      }
      const qParams = {
        PageIndex: this.tb.pi,
        PageSize: this.tb.ps,
        Where: {
          UserName: this.qForm.UserName,
          MatchId: this.qForm.MatchId,
          GroupId: this.qForm.GroupId,
          ProjectId: this.qForm.ProjectId,
          UnitName: this.qForm.UnitName,
        },
      };
      this.allLoading = true;
      MatchService.selectMatchContestantUser(qParams).then(res => {
        this.allLoading = false;
        if (res.code == 0) {
          this.tb.pi = res.data.PageIndex;
          this.tb.ps = res.data.PageSize;
          this.tb.data = res.data.Data;
          this.tb.total = res.data.TotalRow;

          this.tb.data.forEach(item => {
            item.ProNameAndGender = item.ProjectName + '(' + this.genderRuleArr[item.GenderRule] + ')';
            item.GenderText = this.genderRuleArr[item.Gender];
            item.Birthday = item.Birthday && item.Birthday.indexOf('T') > -1 ? item.Birthday.split('T')[0] : item.Birthday;
          })
        }
      })

    },
    handleSizeChange(val) {
      this.tb.ps = val;
      this.query(true);
    },
    handleCurrentChange(val) {
      this.tb.pi = val;
      this.query(false);
    },
    remoteMethod(query) {
      if (query !== '') {
        this.matchOptions = this.allMatchs.filter(item => {
          return item.MatchName.indexOf(query) > -1
        })
      } else {
        this.matchOptions = this.allMatchs
      }

    },
    matchClear() {
      this.matchOptions = this.allMatchs;
    },

    getAllMatchs() {
      MatchService.selectMatchListByName({ matchName: '' }).then(res => {
        if (res.code == 0) {
          this.allMatchs = res.data;
          this.matchOptions = this.allMatchs
        }
      })
    },
    matchSelectChange() {
      this.qForm.GroupId = '';
      this.qForm.ProjectId = ''
      this.match = null;
      this.projects = [];
      if (this.qForm.MatchId != '') {
        MatchService.getMatchDetail({ matchId: this.qForm.MatchId }).then(res => {
          if (res.code == 0) this.match = res.data;
        })

        MatchService.selectMatchRelatUnitNameList({ matchId: this.qForm.MatchId }).then(res => {
          if (res.code == 0) {
            this.allUnits = [];
            res.data.forEach(item => {
              this.allUnits.push({
                address: item,
                value: item,
              });
            })
            // this.allUnits = res.data;
          }
        })
      }
    },
    groupSelectChange() {
      this.qForm.ProjectId = '';
      this.projects = [];
      if (this.qForm.GroupId == '') {
        if (this.match != null) {
          this.match.MatchGroups.forEach(element => {
            this.projects.concat(element.Projects);
          });
        }
      } else {

        this.match.MatchGroups.filter(item => item.GroupId === this.qForm.GroupId).forEach(g => {
          this.projects = g.Projects;

        })
      }
      if (this.projects.length > 0) {
        this.projects.forEach(element => {
          element.label = element.ProjectName + '(' + this.genderRuleList.find(r => r.value == element.GenderRule).label + ')';
        });
      }
    },
    showEditDialog(data) {
      if (data) {
        this.editForm = data;
        MatchService.getMatchDetail({ matchId: this.editForm.MatchId }).then(res => {
          if (res.code == 0) {
            this.editFormMatch = res.data;
            this.editFormProject = this.editFormMatch.MatchGroups.find(g => g.GroupId == this.editForm.GroupId).Projects;
          }
        })

        MatchService.selectMatchRelatUnitNameList({ matchId: this.editForm.MatchId }).then(res => {
          if (res.code == 0) {
             this.allUnits = [];
            res.data.forEach(item => {
              this.allUnits.push({
                address: item,
                value: item,
              });
            })
          }
        })

      } else {
        this.editForm = {
          UserId: '',
          UserName: '',
          Gender: 0,
          Birthday: null,
          ProjectId: '',
          SignUpTime: null,
          IdentityCard: '',
          Unit: '',
          Remarks: '',
          SignUpTime: new Date()
        }

      }

      this.editDialogVisible = true;
    },

    showUserReplaceDialog(row) {
      this.editReplaceForm.UserId = row.UserId;
      this.editReplaceForm.UserName = row.UserName;
      this.editReplaceForm.OldAthleteIds = row.AthleteIds.split(',');
      this.editReplaceForm.NewAthleteIds = row.AthleteIds.split(',');
      //获取该单位运动员列表
      MatchService.selectUnitAthleteByUnitSignFormId({ unitSignFormId: row.SignUpFormId }).then(res => {
        if (res.code == 0) {
          this.unitAthletes = res.data;
          this.editReplaceDialogVisible = true;
        }
      })
    },
    submitReplaceForm() {
      if (this.editReplaceForm.NewAthleteIds.length == 0) {
        this.$message.error('请选择运动员');
        return;
      } else if (this.editReplaceForm.NewAthleteIds.length != this.editReplaceForm.OldAthleteIds.length) {
        this.$message.error('选择的运动员人数与原运动员人数不一致');
        return;
      }

      MatchService.submitReplaceAthlete({
        UserId: this.editReplaceForm.UserId,
        NewAthleteIds: this.editReplaceForm.NewAthleteIds.join(',')
      }).then(res => {
        if (res.code == 0) {
          this.$message.success(res.data);
          this.editReplaceDialogVisible = false;
          this.query(false);
        }
      })
    },

    editMatchChange() {
      this.editForm.GroupId = '';
      this.editForm.ProjectId = ''
      this.editFormGroups = [];
      this.editFormProject = [];
      if (!this.editForm.MatchId == '') {

        MatchService.getMatchDetail({ matchId: this.editForm.MatchId }).then(res => {
          if (res.code == 0) {
            this.editFormMatch = res.data;
          }
        })

        MatchService.selectMatchRelatUnitNameList({ matchId: this.editForm.MatchId }).then(res => {
          if (res.code == 0) {
             this.allUnits = [];
            res.data.forEach(item => {
              this.allUnits.push({
                address: item,
                value: item,
              });
            })
          }
        })

      }
    },
    editGroupChange() {
      //this.forceRefreshForm();
      this.editFormProject = [];
      this.editForm.ProjectId = '';
      this.editFormProject = this.editFormMatch.MatchGroups.find(g => g.GroupId == this.editForm.GroupId).Projects;
      if (this.editFormProject) {
        this.editFormProject.forEach(element => {
          element.ProjectName = element.ProjectName + '(' + this.genderRuleList.find(r => r.value == element.GenderRule).label + ')';
        });
      }
    },
    submitSignUpForm() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          this.editForm.SignUpTime = utilsCommon.formatDate(this.editForm.SignUpTime, 'YYYY-MM-DDTHH:mm:ss');
          if (!this.editForm.ComeOnGroup) this.editForm.ComeOnGroup = 0;
          MatchService.editMatchContestantUser(this.editForm).then(res => {
            if (res.code == 0) {
              this.$message.success(res.data);
              this.editDialogVisible = false;
              this.query(false);
            }
          })
        }
      });
    },
    deleteMatchContestantUser(row) {
      this.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        MatchService.deleteMatchContestantUser({ userId: row.UserId }).then(res => {
          if (res.code == 0) {
            this.$message.success('删除成功');
            this.query(false);
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      })
    },
    sunmitUpload() {
      this.$refs.upload.submit();
    },
    showUploadDialog() {
      this.uploadData.matchId = '';
      this.uploadFileList = [];
      this.uploadDialogVisible = true;
    },
    uploadRequestChange(e) {
      console.log(e);
    },
    uploadSuccess(response, file, fileList) {
      if (response.isError) {
        this.$message.error(response.msg);
      } else {
        //上传成功
        this.$message.success(response.data);
        this.uploadData.matchId = '';
        this.uploadFileList = [];
        this.uploadDialogVisible = false;
        this.query(false)
      }
    },
    uploadError(response, file, fileList) {
      if (response.status == 401) {
        this.$message.error('登录失效，请重新登录');
        Router.replace({ path: '/login', query: { redirect: Router.currentRoute.path == "/login" ? "" : Router.currentRoute.path } });
      } else if (response.status == 500) {
        this.$message.error('上传失败');
      }
    },

    dataformatter(row, column, value) {
      return utilsCommon.formatDate(value, 'YYYY-MM-DD HH:mm:ss')
    },
    downloadTemplate() {
      location.href = Url.getDownloadBaseUrl() + '/templatefiles/报名导入模版.xlsx';
    }
  },
  computed: {

  },
};
</script>
